import {RefillStatus} from './refill-status';
import { environment } from '../../environments/environment';
import {Travel} from './travel';

export class Refill {
	public id: number;
	public box_pic: Blob;
	public recive_pic: Blob;
	public box_pic_onlinepath: string;
	public recive_pic_onlinepath: string;
	public kilometers: string;
	
	public latitude: string;
	public longitude: string;
	public altitude: string;
	
	public quantity: string;
	public amount: string;
	public fuel_level: string;
	public status: RefillStatus;
	public travel: Travel;
	public made_at: Date;
	public handled_at: Date;
	public closed_at: Date;
	public prefix: string;

	public gui = {
		is_collapsed: true
	};

	constructor(server_obj: any) {
		this.prefix = 'rfl_';
		if (server_obj) {
			this.id = Number(server_obj[this.prefix + 'id']);
			this.box_pic_onlinepath = environment.api.baseUrl + 'downloads/image/' + server_obj[this.prefix + 'box_pic'];
			this.recive_pic_onlinepath = environment.api.baseUrl + 'downloads/image/' + server_obj[this.prefix + 'recive_pic'];
			this.kilometers = server_obj[this.prefix + 'kilometers'];
			
			this.latitude = server_obj[this.prefix + 'latitude'];
			this.longitude = server_obj[this.prefix + 'longitude'];
			this.altitude = server_obj[this.prefix + 'altitude'];
			
			this.quantity = server_obj[this.prefix + 'quantity'];
			this.amount = server_obj[this.prefix + 'amount'];
			this.fuel_level = server_obj[this.prefix + 'fuel_level'];
			this.made_at = new Date(server_obj[this.prefix + 'made_at'].replace(/-/g, '/'));

			this.status = new RefillStatus(server_obj);
			this.travel = new Travel(server_obj);

			if (server_obj[this.prefix + 'handled_at']) {
				this.handled_at = new Date(server_obj[this.prefix + 'handled_at']);
			} else {
				this.handled_at = null;
			}
			if (server_obj[this.prefix + 'closed_at']) {
				this.closed_at = new Date(server_obj[this.prefix + 'closed_at'].replace(/-/g, '/'));
			} else {
				this.closed_at = null;
			}
		} else {
			this.status = new RefillStatus(undefined);
			this.travel = new Travel(undefined);
			this.made_at = new Date();
		}
	}
}
